export default {
  addressesStore: {
    addressInvalid: true
  }
};
